import Modal from '../../../components/Modal';
import { FormTypes } from '../../../components/FormGenerator';
import VenueRegistrationFormModal from '../shared/VenueRegistrationFormModal';
import Manipulator from '../../../utils/dom/manipulator';
import {
	CARD_OR_BACS,
	createStripeCheckoutSession,
	isFreeDemoRequest
} from './checkout';

class SubmitRegistration extends VenueRegistrationFormModal {
	constructor() {
		super({
			wrapperSelector: '.p-venue-registration-submit-landing',
			sectionWrapperSelector: null,
			modalSelector: '#js-submit-registration-form-modal',
			triggerSelectors: ['.js-submit-registration .lta-confirm-section__btn'],
			stepsEndpointAttr: 'submit-registration-steps-endpoint',
			submitEndpointAttr: 'submit-registration-submit-endpoint',
			logPrefix: 'SubmitRegistration'
		});
	}

	init() {
		super.init();
		if (!this._wrapper) {
			return;
		}

		this.paymentEndpoint = Manipulator.getDataAttribute(
			this.sectionWrapper,
			'submit-registration-payment-endpoint'
		);

		// Used for backend pricing / step selection. Treat as untrusted UI input.
		this.isMultiSite = !!Manipulator.getDataAttribute(this.sectionWrapper, 'submit-registration-is-multi-site');
	}

	getFormGeneratorOptions() {
		const isFree = Number(this.checkoutData?.totalCost) === 0;

		return {
			totalSteps: this.totalSteps,
			formType: FormTypes.StepForm,
			hasSeparator: false,
			isBackButtonEnabled: true,
			radioAnswerField: 'id',
			isRenderDependentQuestion: true,
			conditionalStepsVisiblity: true,
			isHideProgress: true,
			exitButtonLabel: 'Save and exit',
			exitButtonClasses: 'lta-form-generator__form-exit-button--underlined',
			nextStepButtonLabel: isFree ? 'Submit registration' : 'Save and continue',
			showExitWithoutSavingButton: true,
			exitWithoutSavingButtonLabel: 'Exit without saving',
			exitWithoutSavingButtonHandler: () => this.closeFormModal(),
			submitButton: {
				title: 'Submit registration',
				alwaysVisible: true
			}
		};
	}

	getRequestParam() {
		return {
			...super.getRequestParam(),
			isMultiSite: this.isMultiSite,
			...(isFreeDemoRequest() ? { free: '1' } : {})
		};
	}

	async openFormModal(mode = 'add') {
		if (!this.formModalComponent?.modalEl) {
			return;
		}

		this.formMode = mode;

		if (!this.formModalInstance) {
			this.formModalInstance = new Modal(this.formModalComponent.modalEl, { backdrop: 'static' });
			this.formModalInstance.isEscapeEventEnable = false;
		}

		this.formGenerator?.unload();
		this.formGenerator = null;
		this.hideError();
		this.formModalInstance.show();
		await this.fetchProgramSteps();
	}

	async submitProgramDetails(shouldModalClose = true) {
		// Save & exit / step-change should not start Stripe checkout
		if (!shouldModalClose) {
			return true;
		}

		const paymentMethod = this.answerList?.paymentMethod;

		if (CARD_OR_BACS.has(paymentMethod)) {
			const result = await createStripeCheckoutSession(this.paymentEndpoint, {
				paymentMethod,
				checkoutData: this.checkoutData,
				isLocal: this.config.isLocal
			});

			if (!result.ok) {
				this.showError(result.errorMessage);
				if (this.formGenerator?.nextButtonEl) {
					this.formGenerator.nextButtonEl.disabled = false;
				}
				return false;
			}

			this.goToUrl(result.redirectUrl);
			return true;
		}

		return super.submitProgramDetails(shouldModalClose);
	}
}

VenueRegistrationFormModal.boot(SubmitRegistration);

export default SubmitRegistration;
